export default __webpack_public_path__ + "static/media/NBK_logo_WH.e2eb723f.png";